import React from 'react';
import GeckoFieldBase from '../_base.jsx';
import '../select_multi/react-select-plus.css';
import './select_create_multi.scss';
import Select from 'react-select-plus'; //https://github.com/HubSpot/react-select-plus

class GeckoFieldSelectCreateMulti extends GeckoFieldBase {
  handleChange(option) {
    return this.props.handler.bind(
      this,
      this.field().key,
      this.prepareValue(option)
    )();
  }

  prepareValue(values) {
    return values.map((v) => v.value);
  }

  prepareOptions() {
    // When the create option is run then a string value is put into the values, in order for it to show we need to make an option for it.
    const options = this.options();
    const value = this.value();
    if (!value || !Array.isArray(value)) {
      return options;
    }
    // Get any values not in the options array
    const createdValues = this.value().filter((val) => {
      return !options.find((opt) => opt.value === val);
    });
    // Create options for each value that has been created
    const createdOptions = createdValues.map((val) => {
      return { label: val, value: val };
    });
    return createdOptions.concat(options);
  }

  render() {
    const inputProps = Object.assign(
      { autoComplete: 'off' },
      this.config().inputProps || {}
    );
    return (
      <Select.Creatable
        id={this.renderId()}
        className="gecko-ui-material"
        value={this.value()}
        options={this.prepareOptions()}
        onChange={this.handleChange.bind(this)}
        multi={true}
        disabled={this.isDisabled()}
        placeholder={this.field().placeholder}
        inputProps={inputProps}
        {...this.config()}
      />
    );
  }
}

export default GeckoFieldSelectCreateMulti;
